module.exports = __webpack_public_path__ + "img/central-african-republic.da0ec0b8.svg";